import styled from 'styled-components';
import { h3, h4 } from 'styles/Typography';

export const SiteSelectListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s3);
  overflow: auto;
  margin-bottom: var(--s3);
  padding-bottom: var(--s2);
`;

export const SiteSelectWrapper = styled.div`
  border: 0.125rem solid var(--greenprimary);
  border-radius: var(--s3);
  padding: var(--s2) var(--s3);
  display: flex;
  align-items: center;
  gap: var(--s3);
  flex-wrap: wrap;
`;
export const SiteSelectName = styled.div`
  ${h3};
  font-weight: 600;
  margin-bottom: var(--s2);
`;

export const SiteSelectShortInfo = styled.div`
  ${h4};
  font-weight: normal;
`;
